



































import Vue from 'vue'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import Select from '@/components/additional-fields/AdditionalFieldsSelect.vue'
import Check from '@/components/additional-fields/AdditionalFieldsCheck.vue'
import NumberField from '@/components/additional-fields/AdditionalFieldsNumber.vue'
import FieldsText from '@/components/additional-fields/AdditionalFieldsText.vue'
import Textarea from '@/components/additional-fields/AdditionalFieldsTextArea.vue'
import Email from '@/components/additional-fields/AdditionalFieldsEmail.vue'
import FieldsDatePicker from '@/components/additional-fields/AdditionalFieldsDatePicker.vue'
import SelectMultiple from '@/components/additional-fields/AdditionalFieldsSelectMultiple.vue'
import DecimalNumber from '@/components/additional-fields/AdditionalFieldsDecimalNumber.vue'
import { FETCH_ADDRESS_ADDITIONAL, SAVE_ADDRESS_ADDITIONAL } from '@/store/action-types'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'
import { AdditionalFieldsPayload, AdditionalFieldsPayloadItem } from '@/types/payload'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { TranslateResult } from 'vue-i18n'
import { SnackbarStateEnum } from '@/types/enums'
import MultiLanguageTextArea from '@/components/additional-fields/AdditionalFieldsMultiLanguageTextArea.vue'

interface ComponentData {
  active: number[]
  treeItemList: AdditionalGroup[] | null
  componentTypeMap: Map<number, string>
  selectedData: AdditionalFieldItem[]
  showSnackbar: boolean
  snackbarState: number
  messageSnackbar: TranslateResult | string
  loading: boolean
  noValid: number[]
}

export default Vue.extend({
  name: 'AdditionalFields',

  components: {
    Select,
    NumberField,
    FieldsText,
    Check,
    Textarea,
    Email,
    FieldsDatePicker,
    SelectMultiple,
    DecimalNumber,
    MultiLanguageTextArea
  },

  props: {
    addressId: Number,
    refreshAdditionalFields: Boolean
  },

  data (): ComponentData {
    return {
      active: [],
      treeItemList: [],
      componentTypeMap: new Map([
        [2, 'Select'], [4, 'DecimalNumber'], [1, 'FieldsText'], [21, 'Textarea'], [3, 'Check'], [6, 'Email'], [11, 'FieldsDatePicker'], [5, 'SelectMultiple'], [8, 'MultiLanguageTextArea'], [20, 'MultiLanguageTextArea']
      ]),
      selectedData: [],
      showSnackbar: false,
      snackbarState: 0,
      messageSnackbar: '',
      loading: false,
      noValid: []
    }
  },

  watch: {
    addressId (newVal: number): void {
      if(newVal && newVal !== 0) {
        this.treeItemList = []
        this.selectedData = []
        this.fetchAdditionalData()
      }
    },

    refreshAdditionalFields (newVal: boolean): void {
      if(newVal) {
        this.treeItemList = []
        this.selectedData = []
        this.fetchAdditionalData()
        this.$emit('refreshed')
      }
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },

    isSaveDisabled (): boolean {
      return this.noValid.length !== 0
    }
  },

  methods: {
    onValueChange (data: AdditionalFieldItem): void {
      if(data.componentId === 11) {
        if(data.value) {
          const pattern = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
          if (!pattern.test(data.value)) {
            if (!this.noValid.includes(data.parentType)) {
              this.noValid.push(data.parentType)
            }
          } else {
            if (this.noValid.includes(data.parentType)) {
              const index: number = this.noValid.indexOf(data.parentType)
              this.noValid.splice(index, 1)
            }
          }
        } else {
          if (this.noValid.includes(data.parentType)) {
            const index: number = this.noValid.indexOf(data.parentType)
            this.noValid.splice(index, 1)
          }
        }
      }

      const foundData: AdditionalFieldItem | undefined = this.selectedData.find((item: AdditionalFieldItem) => item.parentType === data.parentType)
      if(foundData) {
        const index: number = this.selectedData.indexOf(foundData)
        this.selectedData.splice(index, 1, data)
      } else {
        this.selectedData.push(data)
      }

      if(this.treeItemList) {
        this.treeItemList.forEach((group: AdditionalGroup) => {
          if (group.id === data.groupId) {
            group.children.forEach((field: AdditionalField, idx: number) => {
              if (field.type === data.parentType) {
                const updatedField: AdditionalField = AdditionalField.updateValue(field, data.value)
                group.children.splice(idx, 1, updatedField)
              }
            })
          }
        })
      }
    },

    onSaveButtonClick (): void {
      const fields: AdditionalFieldsPayloadItem[] = this.selectedData.map((item: AdditionalFieldItem) => {
        return {"Feldtyp": item.parentType, "Art": item.componentId, "Value": item.value}
      })

      const payload: AdditionalFieldsPayload = {
        fields: fields,
        addressId: this.addressId
      }
      this.saveAdditionalFields(payload)
    },

    async saveAdditionalFields (payload: AdditionalFieldsPayload): Promise<void> {
      try {
        this.loading = true
        const response: boolean = await this.$store.dispatch(SAVE_ADDRESS_ADDITIONAL, payload)
        this.loading = false
        this.selectedData = []
        if(response) {
          this.messageSnackbar = this.$t('success.dataHaveBeenSaved')
          this.snackbarState = SnackbarStateEnum.Success
          this.showSnackbar = true
          await this.fetchAdditionalData()
        }
      } catch (e) {
        this.loading = false
        this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    },

    async fetchAdditionalData (): Promise<void> {
      try {
        this.treeItemList = await this.$store.dispatch(FETCH_ADDRESS_ADDITIONAL, this.addressId)
        setTimeout(() => {
          const tree: any = this.$refs['tree']
          if(tree) {
            const firstElement = tree.$el.querySelector('.v-treeview-node__toggle--open')
            if (firstElement) {
              firstElement.focus()
            }
          }
        }, 0)
      } catch {
        this.messageSnackbar = this.$t('errors.dataCouldNotBeRead')
        this.snackbarState = SnackbarStateEnum.Error
        this.showSnackbar = true
      }
    }
  },

  mounted () {
    this.fetchAdditionalData()
  }

})
